// src/data/gyms/RocketCheer.js
export const RocketCheer = {
  id: "rocketcheer",
  name: "Rocket Cheer",
  color: "#EA580C", // Rocket Orange
  lightColor: "#FFF7ED",
  logo: "🚀",

  teams: [
    { id: "aces", name: "Aces", level: "L1.1 Youth - PREP" },
    { id: "showgirls", name: "Showgirls", level: "L4 Senior - D2" },
    { id: "goldengirls", name: "Golden Girls", level: "L5 Junior - D2" },
    { id: "magic", name: "Magic", level: "L1 Mini - D2" },
    { id: "highrollers", name: "High Rollers", level: "L1 Youth - Flex - D2" },
    { id: "ladyluck", name: "Lady Luck", level: "L2 Junior - Flex - D2" },
    { id: "jokers", name: "Jokers", level: "L3 Youth - Flex - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "9:20 AM",
      teamId: "aces",
      meet: "8:44 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "11:18 AM",
      teamId: "showgirls",
      meet: "10:42 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "1:16 PM",
      teamId: "goldengirls",
      meet: "12:40 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:16 PM",
      teamId: "magic",
      meet: "2:40 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:26 PM",
      teamId: "highrollers",
      meet: "2:50 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:01 PM",
      teamId: "ladyluck",
      meet: "3:25 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "6:21 PM",
      teamId: "jokers",
      meet: "5:45 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // Showgirls (Row 149)
    {
      day: "Sunday",
      time: "9:21 AM",
      teamId: "showgirls",
      meet: "8:45 AM",
      panel: "Hall A",
    },

    // Golden Girls (Row 167)
    {
      day: "Sunday",
      time: "10:31 AM",
      teamId: "goldengirls",
      meet: "9:55 AM",
      panel: "Hall A",
    },

    // Magic (Row 199)
    {
      day: "Sunday",
      time: "12:49 PM",
      teamId: "magic",
      meet: "12:13 PM",
      panel: "Hall A",
    },

    // High Rollers (Row 200)
    {
      day: "Sunday",
      time: "12:53 PM",
      teamId: "highrollers",
      meet: "12:17 PM",
      panel: "Hall B",
    },

    // Lady Luck (Row 211)
    {
      day: "Sunday",
      time: "2:21 PM",
      teamId: "ladyluck",
      meet: "1:45 PM",
      panel: "Hall B",
    },

    // Jokers (Row 240)
    {
      day: "Sunday",
      time: "4:35 PM",
      teamId: "jokers",
      meet: "3:59 PM",
      panel: "Hall B",
    },
  ],
};
